export default __webpack_public_path__ + "static/media/1891.26ca97fc.png";